import React from 'react';
import css from './StatusModal.module.css';
import Icons from '../Icons/Icons';
import {
  InlineTextButton,
  PrimaryButton,
  SecondaryButton,
  SecondaryButtonInline,
} from '../Button/Button';
import classNames from 'classnames';

function StatusModal(props) {
  const { isSuccessModal, isFailModal } = props;
  return (
    <div
      className={classNames(
        css.statusModalContent,
        isSuccessModal ? css.successModal : null,
        isFailModal ? css.failModal : null
      )}
    >
      {isSuccessModal ? (
        <>
          <div className={css.statusModalHead}>
            <h2>
              <Icons name="checkCircleSuccess" /> Project Brief Submitted
            </h2>
          </div>
          <div className={css.statusModalBody}>
            <p>Thank you for uploading your project details, documents & designs</p>
            <p>
              Our team will now <strong>review your submission </strong> and be in touch shortly to{' '}
              <strong>book a follow-up call</strong>
              to discuss the next steps.
            </p>
            <p>
              While the cost estimation tool is temporarily unavailable, rest assured we're working
              behind the scenes to match your project with the most suitable suppliers.
            </p>
            <p>
              If you have any questions in the meantime, feel free to contact us at: <br />
              <a href="mailto?info@themodernbuilder.co.uk">info@themodernbuilder.co.uk</a> or{' '}
              <a href="tel:03330902430">03330902430</a>
            </p>
          </div>
          <div className={css.statusModalFooter}>
            <InlineTextButton className={css.noBtn}>No</InlineTextButton>
            <PrimaryButton className={css.yesBtn}>Yes</PrimaryButton>
          </div>
        </>
      ) : (
        <>
          <div className={css.statusModalHead}>
            <h2>
              <Icons name="crossCircleFail" /> Project Brief Submitted
            </h2>
          </div>
          <div className={css.statusModalBody}>
            <p>Thank you for uploading your project details, documents & designs</p>
            <p>
              Our team will now <strong>review your submission </strong> and be in touch shortly to{' '}
              <strong>book a follow-up call</strong>
              to discuss the next steps.
            </p>
            <p>
              While the cost estimation tool is temporarily unavailable, rest assured we're working
              behind the scenes to match your project with the most suitable suppliers.
            </p>
            <p>
              If you have any questions in the meantime, feel free to contact us at: <br />
              <a href="mailto?info@themodernbuilder.co.uk">info@themodernbuilder.co.uk</a> or{' '}
              <a href="tel:03330902430">03330902430</a>
            </p>
          </div>
          <div className={css.statusModalFooter}>
            <InlineTextButton className={css.noBtn}>No</InlineTextButton>
            <PrimaryButton className={css.yesBtn}>Yes</PrimaryButton>
          </div>
        </>
      )}
    </div>
  );
}

export default StatusModal;
